<template>
  <div class="upload-page">
    <!-- 顶部头部 -->
    <div class="page-header">
      <div class="header-icon">
        <svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect x="8" y="4" width="32" height="40" rx="3" stroke="#1989fa" stroke-width="2" />
          <circle cx="24" cy="38" r="2" fill="#1989fa" />
          <rect x="12" y="10" width="24" height="18" rx="1" fill="#E6F3FF" />
          <path d="M15 28L20 23L24 27L31 20L36 26V30H15V28Z" fill="#1989fa" fill-opacity="0.3" />
          <path d="M20 18C20 19.6569 18.6569 21 17 21C15.3431 21 14 19.6569 14 18C14 16.3431 15.3431 15 17 15C18.6569 15 20 16.3431 20 18Z" fill="#1989fa" />
        </svg>
      </div>
      <h1 class="page-title">上传物流照片</h1>
      <p class="page-desc">上传后电脑端将自动同步显示</p>
    </div>

    <!-- 订单信息 -->
    <div v-if="orderSn" class="order-card">
      <div class="order-icon">
        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M20 7H4C3.44772 7 3 7.44772 3 8V19C3 19.5523 3.44772 20 4 20H20C20.5523 20 21 19.5523 21 19V8C21 7.44772 20.5523 7 20 7Z" stroke="#1989fa" stroke-width="2" />
          <path d="M16 3V7H8V3" stroke="#1989fa" stroke-width="2" stroke-linecap="round" />
          <path d="M7 12H17" stroke="#1989fa" stroke-width="2" stroke-linecap="round" />
          <path d="M7 16H14" stroke="#1989fa" stroke-width="2" stroke-linecap="round" />
        </svg>
      </div>
      <div class="order-info">
        <span class="order-label">订单编号</span>
        <span class="order-sn">{{ orderSn }}</span>
      </div>
    </div>

    <!-- 上传区域 -->
    <div class="upload-section">
      <div class="upload-header">
        <div class="upload-title">
          <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M21 15V19C21 19.5304 20.7893 20.0391 20.4142 20.4142C20.0391 20.7893 19.5304 21 19 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V15" stroke="#1989fa" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M17 8L12 3L7 8" stroke="#1989fa" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M12 3V15" stroke="#1989fa" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
          </svg>
          <span>添加照片</span>
        </div>
        <span class="upload-count">{{ fileList.length }}/3</span>
      </div>

      <van-uploader
        v-model="fileList"
        :after-read="afterRead"
        :before-read="beforeRead"
        class="uploader"
        :max-count="3"
        :preview-size="100"
        image-fit="cover"
        :deletable="false">
        <div v-if="fileList.length < 3" class="upload-btn">
          <div class="upload-btn-icon">
            <svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M24 14V34" stroke="#1989fa" stroke-width="3" stroke-linecap="round" />
              <path d="M14 24H34" stroke="#1989fa" stroke-width="3" stroke-linecap="round" />
              <rect x="4" y="4" width="40" height="40" rx="8" stroke="#1989fa" stroke-width="2" stroke-dasharray="6 4" />
            </svg>
          </div>
          <span class="upload-btn-text">点击上传</span>
          <span class="upload-btn-hint">支持拍照或相册选择</span>
        </div>
      </van-uploader>
    </div>

    <!-- 提示卡片 -->
    <div class="tips-card">
      <div class="tips-icon">
        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="12" cy="12" r="9" stroke="#FF976A" stroke-width="2" />
          <path d="M12 8V13" stroke="#FF976A" stroke-width="2" stroke-linecap="round" />
          <circle cx="12" cy="17" r="1" fill="#FF976A" />
        </svg>
      </div>
      <div class="tips-content">
        <h4>温馨提示</h4>
        <ul>
          <li>最多上传 3 张照片</li>
          <li>照片将实时同步到电脑端</li>
          <li>如需删除请在电脑端操作</li>
          <li>如果与电脑端数据不一致，请点击<a href="javascript:void(0)" @click="reloadPage()">数据同步</a></li>
        </ul>
      </div>
    </div>

    <!-- 底部成功状态 -->
    <div v-if="hasSuccessUpload && syncLoading" class="success-bar">
      <div class="success-icon">
        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M20 6L9 17L4 12" stroke="white" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
      </div>
      <span>照片已同步到电脑端</span>
    </div>
  </div>
</template>

<script>
import { uploadUrl, qrcodeScan } from '@/api/h5'
import { Toast } from 'vant'
import axios from 'axios'

export default {
  name: 'UploadImage',

  data () {
    return {
      uploadUrl: uploadUrl,
      orderSn: '',
      fileList: [],
      syncLoading: false
    }
  },

  computed: {
    hasSuccessUpload () {
      return this.fileList.some(f => f.status === 'success')
    }
  },

  mounted () {
    this.orderSn = this.$route.query.orderSn || ''
    this.getQrcodeScan()
  },

  methods: {
    getQrcodeScan () {
      qrcodeScan({ orderSn: this.orderSn })
        .then(res => {
          if (res.code !== 1) {
            Toast.fail(res.errMsg)
          } else {
            this.syncLoading = true
            this.fileList = res.data.orderImages.map(item => {
              return {
                url: item,
                status: 'success',
                message: '已上传'
              }
            })
          }
          console.log('qrcodeScan result:', res)
        })
        .catch(err => {
          console.error('qrcodeScan error:', err)
        }).finally(() => {
          const timer = setTimeout(() => {
            this.syncLoading = false
            clearTimeout(timer)
          }, 2000) // 显示同步成功提示2秒后自动隐藏
        })
    },

    beforeRead (file) {
      if (file.type.indexOf('image') === -1) {
        Toast('请选择图片文件')
        return false
      }
      return true
    },

    afterRead (file) {
      file.status = 'uploading'
      file.message = '上传中...'

      const formData = new FormData()
      formData.append('file', file.file)
      formData.append('orderSn', this.orderSn)

      axios.post(this.uploadUrl, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
        .then(res => {
          if (res.data.code === 1) {
            file.status = 'success'
            file.message = '上传成功'
            file.url = res.data.data
            Toast.success('上传成功！')
            this.syncLoading = true
          } else {
            // 上传失败，从列表中移除
            this.removeFailedFile(file)
            Toast.fail(res.data.errMsg)
          }
        })
        .catch((err) => {
          // 上传失败，从列表中移除
          this.removeFailedFile(file)
          Toast.fail('上传失败:' + err.response?.data?.errMsg || '未知错误')
        }).finally(() => {
          const timer = setTimeout(() => {
            this.syncLoading = false
            clearTimeout(timer)
          }, 2000) // 显示同步成功提示2秒后自动隐藏
        })
    },

    removeFailedFile (file) {
      const index = this.fileList.indexOf(file)
      if (index > -1) {
        this.fileList.splice(index, 1)
      }
    },
    reloadPage () {
      this.getQrcodeScan()
    }
  }
}
</script>

<style scoped>
.upload-page {
  min-height: 100vh;
  background: linear-gradient(180deg, #F7F8FA 0%, #F0F2F5 100%);
}

/* 顶部头部 */
.page-header {
  text-align: center;
  padding: 20px 0 32px;
}

.header-icon {
  width: 72px;
  height: 72px;
  margin: 0 auto 16px;
  background: linear-gradient(135deg, #E6F3FF 0%, #FFF 100%);
  border-radius: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 12px rgba(25, 137, 250, 0.1);
}

.header-icon svg {
  width: 44px;
  height: 44px;
}

.page-title {
  font-size: 24px;
  font-weight: 600;
  color: #1D2129;
  margin: 0 0 8px;
}

.page-desc {
  font-size: 14px;
  color: #86909C;
  margin: 0;
}

/* 订单卡片 */
.order-card {
  background: #FFF;
  border-radius: 16px;
  padding: 16px 20px;
  display: flex;
  align-items: center;
  margin-bottom: 16px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
}

.order-icon {
  width: 40px;
  height: 40px;
  background: linear-gradient(135deg, #E6F3FF 0%, #F0F7FF 100%);
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 12px;
  flex-shrink: 0;
}

.order-icon svg {
  width: 20px;
  height: 20px;
}

.order-info {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.order-label {
  font-size: 12px;
  color: #86909C;
}

.order-sn {
  font-size: 16px;
  font-weight: 600;
  color: #1D2129;
  font-family: 'SF Mono', 'Monaco', 'Consolas', monospace;
}

/* 上传区域 */
.upload-section {
  background: #FFF;
  border-radius: 16px;
  padding: 20px;
  margin-bottom: 16px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
}

.upload-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;
}

.upload-title {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 15px;
  font-weight: 600;
  color: #1D2129;
}

.upload-title svg {
  width: 18px;
  height: 18px;
}

.upload-count {
  font-size: 13px;
  color: #86909C;
  background: #F2F3F5;
  padding: 2px 8px;
  border-radius: 10px;
}

/* 上传按钮 */
.upload-btn {
  width: 100%;
  height: 140px;
  border: 2px dashed #CFD8DC;
  border-radius: 12px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  transition: all 0.3s;
  background: linear-gradient(180deg, #FAFBFC 0%, #F7F8FA 100%);
}

.upload-btn:active {
  transform: scale(0.98);
  border-color: #1989fa;
  background: #E6F3FF;
}

.upload-btn-icon {
  width: 52px;
  height: 52px;
  margin-bottom: 4px;
}

.upload-btn-text {
  font-size: 15px;
  font-weight: 500;
  color: #1989fa;
}

.upload-btn-hint {
  font-size: 12px;
  color: #86909C;
}

/* Vant Uploader 覆盖 */
.uploader {
  width: 100%;
}

:deep(.van-uploader__wrapper) {
  gap: 12px;
}

:deep(.van-uploader__upload) {
  margin: 0;
  width: 100px;
  height: 100px;
}

:deep(.van-uploader__preview) {
  margin: 0;
  width: 100px;
  height: 100px;
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);
}

:deep(.van-uploader__preview-image) {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

:deep(.van-uploader__preview-delete) {
  width: 22px;
  height: 22px;
  background: rgba(0, 0, 0, 0.6);
  border-radius: 50%;
}

:deep(.van-uploader__preview-delete::before),
:deep(.van-uploader__preview-delete::after) {
  width: 12px;
  height: 2px;
}

/* 提示卡片 */
.tips-card {
  background: linear-gradient(135deg, #FFF7E6 0%, #FFF 100%);
  border-radius: 16px;
  padding: 18px 20px;
  display: flex;
  gap: 12px;
  margin-bottom: 16px;
  border: 1px solid #FFE7BA;
}

.tips-icon {
  width: 36px;
  height: 36px;
  flex-shrink: 0;
}

.tips-content h4 {
  font-size: 14px;
  font-weight: 600;
  color: #FF7D00;
  margin: 0 0 8px;
}

.tips-content ul {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.tips-content li {
  font-size: 12px;
  color: #86754D;
  padding-left: 14px;
  position: relative;
}

.tips-content li::before {
  content: '';
  position: absolute;
  left: 4px;
  top: 7px;
  width: 4px;
  height: 4px;
  border-radius: 50%;
  background: #FFB84D;
}

/* 底部成功条 */
.success-bar {
  position: fixed;
  left: 16px;
  right: 16px;
  top: 24px;
  background: linear-gradient(135deg, #07C160 0%, #06AD56 100%);
  color: white;
  padding: 14px 20px;
  border-radius: 14px;
  display: flex;
  align-items: center;
  gap: 10px;
  box-shadow: 0 4px 16px rgba(7, 193, 96, 0.35);
  animation: slideUp 0.4s ease;
  z-index: 100;
}

@keyframes slideUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.success-icon {
  width: 24px;
  height: 24px;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.success-icon svg {
  width: 16px;
  height: 16px;
}

.success-bar span {
  font-size: 14px;
  font-weight: 500;
}
</style>
